import template from './tsz-company-settings.html';
import './tsz-company-settings.styl';

function controller($localStorage, $tszToast, CompanyService, AuthService, Upload) {

  'ngInject';

  this.company = {};

  this.loadCompanySettings = () => {
    CompanyService.get(this.companyId)
    .then((response) => {
      this.company = response.toJSON();
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al cargar los detalles de la compañía');
    });
  };

  this.updateCompanySettings = () => {
    const c = {
      name: this.company.name,
      cif: this.company.cif,
    };
    CompanyService.update(this.companyId, c)
    .then((response) => {
      this.company = response.toJSON();
      AuthService.mergeCredentials({
        companyId: this.company.id,
        companyName: this.company.name,
        cif: this.company.cif,
      });
      $tszToast.showSuccess('Perfil guardado');
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al guardar los detalles de la compañía');
    });
  };

  this.uploadFile = (file) => {
    Upload.upload({
      url: `/api/companies/${this.company.id}/logo`,
      file,
    })
    .success((data, status, headers, config) => {
      console.log(`file ${config.file.name} uploaded. Response: ${data}`);
      this.company.logo = data;
      $localStorage.user.logo = data;
      AuthService.setCredentials($localStorage.user);
      $tszToast.showSuccess('Logo atualizado correctamente');
    });
  };

  //
  // INIT
  //

  this.loadCompanySettings();

}

export default {
  template,
  bindings: {
    companyId: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-company-settings/tsz-company-settings.js